module.exports = __webpack_public_path__ + "img/mini-video-play-icon.82efa87c.png";